import { IAuditEvent } from '../hooks/reactQuerys/AuditQueries';

/**
 * Die Warnungen, über die sich jemand beim Speichern bewusst hinweggesetzt hat
 * (#1283/#1330).
 *
 * Sie stehen im `Metadata` des Ereignisses und werden in der Zeile erst auf
 * Klick aufgeklappt — die Zeile selbst nennt nur die Zahl.
 */
export interface IHealthCheckLogWarning {
  ruleKey: string;
  severity: string;
  section: string;
  message: string;
}

/** Ereignistyp, den das Backend beim Speichern trotz Warnungen schreibt. */
export const SAVED_WITH_WARNINGS = 'legal_transaction.saved_with_warnings';

/**
 * Liest die Warnungsliste aus dem Ereignis.
 *
 * Defensiv, weil `Metadata` als JSON in der Datenbank liegt und über Jahre
 * wächst: ein alter oder unerwarteter Inhalt darf die Protokollansicht nicht
 * zerlegen. Im Zweifel eine leere Liste — dann steht nur die Zahl da.
 */
export const healthCheckWarnings = (
  event: IAuditEvent
): IHealthCheckLogWarning[] => {
  const raw = (event.Metadata ?? {})['warnings'];

  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .filter(
      (entry): entry is Record<string, unknown> =>
        typeof entry === 'object' && entry !== null
    )
    .map(entry => ({
      ruleKey: String(entry.ruleKey ?? ''),
      severity: String(entry.severity ?? ''),
      section: String(entry.section ?? ''),
      message: String(entry.message ?? ''),
    }))
    .filter(warning => warning.message !== '');
};

/** true, wenn das Backend die Liste gekappt hat und mehr Funde vorlagen. */
export const healthCheckWarningsTruncated = (event: IAuditEvent): boolean =>
  (event.Metadata ?? {})['truncated'] === true;
